import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useReportAgpGraph from 'hooks/communication/useReportAgpGraph';
import React from 'react';

export default function Template(props) {

  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);

  const setAgpBase = Recoil.useSetRecoilState(AppStore.assets.agp_base);
  const {
    requestReportAgpGraph,
  } = useReportAgpGraph();
  React.useEffect(() => {
    if (!patient_no) return;
    requestReportAgpGraph({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      search_dv: 0,
      search_key: 0,
    }, (success, data) => {
      if (success) {
        setAgpBase(() => data.agp_graph_list);
      }
    });
  }, [period_end, period_start, patient_no, requestReportAgpGraph, setAgpBase]);

  return null;
}
